import GlobeIcon from '@/components/icons/GlobeIcon';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import i18n from '@/i18n/i18n.config';
import { languageOptions } from '@/i18n/options';
import { cn } from '@/lib/utils';
import { FC } from 'react';

type Props = {
	containerClasses?: string;
};

const AccountPopupLanguage: FC<Props> = ({ containerClasses }) => {
	return (
		<Accordion
			type='single'
			collapsible
			className={cn('flex items-center gap-2 text-sm', containerClasses)}>
			<AccordionItem
				value='item-1'
				className='w-full'>
				<AccordionTrigger iconClassName='right-3'>
					<Button
						variant='ghost'
						className={
							'w-full p-3 justify-start gap-2.5 stroke-popover'
						}>
						<GlobeIcon />
						<span>{languageOptions[i18n.language].textFull}</span>
					</Button>
				</AccordionTrigger>
				<AccordionContent className='mt-2 flex flex-col gap-2'>
					{Object.entries(languageOptions).map(([key, value]) => (
						<AccordionTrigger iconClassName='hidden'>
							<Button
								variant='ghost'
								key={key}
								className='w-full p-3 flex items-center justify-between gap-2.5 rounded-semi-xl hover:bg-popover-50 active:bg-popover-100'
								onClick={() => i18n.changeLanguage(key)}>
								{value.textFull}
								<div
									className={cn(
										'size-4 ml-auto border-popover-1000 rounded-full transition-all',
										languageOptions[i18n.language].text ===
											value.text
											? 'border-4'
											: 'border',
									)}
								/>
							</Button>
						</AccordionTrigger>
					))}
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
};

export default AccountPopupLanguage;
